import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './Router';
import {
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import { VoiceProvider } from './VoiceSystem';
const queryClient = new QueryClient();
import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import { CustomBackgroundProvider } from './Contexts/CustomBackground';

Sentry.init({
  dsn: "https://0556bc84ddc0af0177fabb87799bbec8@o4508463227994112.ingest.de.sentry.io/4508463230222416",
  integrations: [
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["teamly.one"],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

import { Toaster } from 'react-hot-toast';

ReactDOM.createRoot(document.getElementById('app') as HTMLElement).render(
  <>
    <React.StrictMode>
      <div className='bg-gradient-to-r sm:px-4 from-brand-darkest to-brand-darkest2 max-h-full -z-20'>
        <div className='absolute top-0 left-0 w-full h-full pointer-events-none' id='background'/>
        <ErrorBoundary isMainScreen={true}>
          <QueryClientProvider client={queryClient}>
            <Router>
              <VoiceProvider>
                <CustomBackgroundProvider>
                  <App />
                </CustomBackgroundProvider>
              </VoiceProvider>
              <Toaster toastOptions={{
                style: {
                  backgroundColor: '#333',
                  color: '#fff',
                },
                success: {
                  duration: 2000,
                },
                error: {
                  duration: 2000,
                  style: {
                    backgroundColor: '#f87171',
                    color: '#fff',
                  },
                  className: 'border border-red-500',
                },
              }} />
            </Router>
          </QueryClientProvider>
        </ErrorBoundary>
      </div>
    </React.StrictMode>
  </>
);